//@flow stric-local
export default class MediaTypeConstant {
  static VIDEO: string = "VIDEO";
  static IMAGE: string = "IMAGE";
  static AUDIO: string = "AUDIO";
  static NONE: string = "NONE";
  static MULTIPAGE: string = "MULTIPAGE";
  static PROJECT: string = "PROJECT";
}